import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { apiFetch } from '../utils/api';
import { useAuth } from '../contexts/AuthContext';
import { JOB_STATUS_LABELS } from '../utils/statusConstants';

const Dashboard = () => {
  const { customer } = useAuth();
  const [requests, setRequests] = useState([]);

  useEffect(() => {
    apiFetch('/requests').then((r) => setRequests((r.data || []).slice(0, 5)));
  }, []);

  return (
    <div>
      <h1 className="text-2xl font-semibold text-slate-900">
        Hello{customer?.name ? `, ${customer.name}` : ''}
      </h1>
      <p className="text-slate-600 text-sm mt-1 mb-6">
        {customer?.accountType === 'residential' ? 'Residential' : 'Commercial'} account ·{' '}
        {customer?.accountName}
      </p>

      <div className="flex gap-3 mb-8">
        <Link
          to="/requests/new"
          className="bg-teal-700 text-white px-4 py-2 rounded-lg text-sm hover:bg-teal-800"
        >
          Request a cleaning
        </Link>
        <Link
          to="/requests"
          className="border border-slate-300 text-slate-700 px-4 py-2 rounded-lg text-sm hover:bg-white"
        >
          View all requests
        </Link>
      </div>

      <div className="bg-white rounded-xl shadow border border-slate-100">
        <h2 className="font-medium px-5 py-4 border-b border-slate-100">Recent requests</h2>
        {requests.length === 0 ? (
          <p className="px-5 py-8 text-sm text-slate-500 text-center">No requests yet</p>
        ) : (
          <ul className="divide-y divide-slate-100">
            {requests.map((j) => (
              <li key={j.id} className="px-5 py-3 flex justify-between items-center">
                <Link to={`/requests/${j.id}`} className="text-teal-700 font-medium text-sm">
                  {j.job_number}
                </Link>
                <span className="text-sm text-slate-600">
                  {JOB_STATUS_LABELS[j.status] || j.status}
                </span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
